import { idPersona } from './../../../../session/store/session.selectors';
import { UltimaFichadaRequested, RecursosHumanosActionTypes, UltimaFichadaLoaded, TicketsPendientesRequested, TicketsPendientesLoaded } from './recursos-humanos.actions';
import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { RecursosHumanosService } from '../../services/recursos-humanos.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { withLatestFrom, mergeMap, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';

@Injectable()
export class RecursosHumanosEffects {

	loadUltimaFichada = createEffect( () =>{
		return this.actions$.pipe(
			ofType<UltimaFichadaRequested>( RecursosHumanosActionTypes.UltimaFichadaRequested ),
			withLatestFrom( this.store.select( idPersona ) ),
			mergeMap( ([ action, idPersona ]) => {
				return this.service.findUltimaFichada( idPersona )
					.pipe(
						catchError( error => {
							this.toastService.danger( "No se pudo obtener la última fichada" );
							return of( null );
						})
					)
			}),
			map( ultimaFichada => new UltimaFichadaLoaded( { ultimaFichada } ) )
		);
	});

	loadTicketsPendientes = createEffect( () => {
		return this.actions$.pipe(
			ofType<TicketsPendientesRequested>( RecursosHumanosActionTypes.TicketsPendientesRequested ),
			withLatestFrom( this.store.select( idPersona ) ),
			mergeMap( ([ action, idPersona ] ) => {
				return this.service.findTicketsPendientes( idPersona )
					.pipe(
						catchError( error => {
							this.toastService.danger( "No se pudieron obtener los tickets pendientes" );
							return of( null );
						})
					)
			}),
			map( ticketsPendientes => new TicketsPendientesLoaded( { ticketsPendientes } ) )
		);
	});

	constructor( private actions$: Actions, private store: Store<AppState>, private service: RecursosHumanosService, private toastService: ToastService ) {
	}

}